module.exports = new __parcel__URL__("cornershop-shopper-welcome.cad18a92.webp").toString();